import { singletonHook } from 'react-singleton-hook';
import useArtifactInfoService from '../artifactInfoService';
import type { ArtifactsInfoResponse } from '../types';
import useCreateArtifactsInfoReceiver, { filterValidArtifactIds } from './createArtifactsInfoReceiver';

type ArtifactsInfoReceiver = {
  hookLoading: boolean;
  collectArtifactsData: (initialAttachmentsIds: string[]) => Promise<ArtifactsInfoResponse['artifacts']>;
};

const initState: ArtifactsInfoReceiver = {
  hookLoading: true,
  collectArtifactsData: async () => ({}),
};

const useArtifactsInfoReceiverImpl = () => {
  const { getArtifactsInfo } = useArtifactInfoService();

  const collectArtifactsData = useCreateArtifactsInfoReceiver({
    getArtifactsInfo,
    getBatchIds: filterValidArtifactIds,
  });

  return {
    hookLoading: false,
    collectArtifactsData,
  };
};

const useArtifactsInfoReceiver = singletonHook(initState, useArtifactsInfoReceiverImpl);

export default useArtifactsInfoReceiver;
